import { render, staticRenderFns } from "./member-benefits.vue?vue&type=template&id=5204df2e&"
import script from "./member-benefits.vue?vue&type=script&lang=js&"
export * from "./member-benefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports